import React, { Fragment, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import R from 'ramda'
import superagent from "superagent";
import { Container, Segment, Dimmer, Loader, Menu, Icon } from "semantic-ui-react";

import { COLORS } from '_constants'
import { getPageData } from '_utils'

import Pagination from '_views/pagination'
import { PluralSearch as UsersSearch } from '_forms/userSearch'

import UserItem from './user'
import AddRoleModal from './addRole'
import { AUTH_API_URL } from '../../constants';
import useIsAuthAdmin from '../../hooks/useIsAuthAdmin';

const UsersPage = (props) => {
  const {
    items,
    request,
    total,
    pageNum,
    perPage,
    autocomplete
  } = getPageData([], props.usersPage)

  const isAuthAdmin = useIsAuthAdmin();
  const [allRoles, setAllRoles] = useState([]);

  useEffect(() => {
    superagent
      .get(`${AUTH_API_URL}/roles?perPage=100`)
      .withCredentials()
      .then((res) => {
        setAllRoles(res.body.results);
      });
  }, []);

  return (
    <Container textAlign='left' fluid style={props.display ? {} : { display: "none" }} >
      <Menu icon='labeled' secondary size='small' color={COLORS.USERS.MENU}>
        <Menu.Menu position='left'>
          <Menu.Item fitted header style={{ maxWidth: "100%" }}>
            <UsersSearch
              autocomplete={autocomplete}
              onTermChange={props.onTermChange}
              onSelectionChange={props.onSelectionChange}
              onClearSuggestions={props.onClearSuggestions}
            />
          </Menu.Item>
        </Menu.Menu>
        <Menu.Menu position='right'>
          <Menu.Item name='refresh' onClick={() => props.onRefreshList(R.pathOr({}, ['navigation'], props.usersPage)) } >
            <Icon name='refresh' />
            Refresh
          </Menu.Item>
          {
            isAuthAdmin ? (
              <Fragment>
                <AddRoleModal/>
              </Fragment>
            ) : null
          }
        </Menu.Menu>
      </Menu>

      <Pagination
        goToPage={props.goToPage}
        pageNum={pageNum}
        perPage={perPage}
        total={total}
      />
      <Segment basic>
        <Dimmer inverted active={request.isLoading === true}>
          <Loader />
        </Dimmer>
        {items.map((u) => (
          <UserItem
            key={u._id}
            user={u}
            setNavigation={props.setNavigation}
            onRemoveUser={props.onRemoveUser}
            onRefreshUser={props.onRefreshUser}
            onModifyUser={props.onModifyUser}
            onAddNote={props.onAddNote}
            onRemoveNote={props.onRemoveNote}
            onAddLicense={props.onAddLicense}
            onRemoveLicense={props.onRemoveLicense}
            onAddSublicense={props.onAddSublicense}
            onRemoveSublicense={props.onRemoveSublicense}
            onRemoveLicenseMachine={props.onRemoveLicenseMachine}
            onReactivateLicense={props.onReactivateLicense}
            onModifyLicense={props.onModifyLicense}
            onDeactivateLicenseUpgrade={props.onDeactivateLicenseUpgrade}
            availableRoles={allRoles}
            isLoading={request.isLoading === u._id}
          />
        ))}
      </Segment>
    </Container>
  )
}

UsersPage.propTypes = {
  display: PropTypes.bool.isRequired,
  // mapStateToProps
  usersPage: PropTypes.object.isRequired,
  // mapDispatchToProps
  onRefreshList: PropTypes.func.isRequired,
  onRefreshUser: PropTypes.func.isRequired,
  onRemoveUser: PropTypes.func.isRequired,
  onModifyUser: PropTypes.func.isRequired,

  setNavigation: PropTypes.func.isRequired,
  goToPage: PropTypes.func.isRequired,

  onTermChange: PropTypes.func.isRequired,
  onSelectionChange: PropTypes.func.isRequired,
  onClearSuggestions: PropTypes.func.isRequired,

  onAddNote: PropTypes.func.isRequired,
  onRemoveNote: PropTypes.func.isRequired,

  onAddLicense: PropTypes.func.isRequired,
  onRemoveLicense: PropTypes.func.isRequired,
  onReactivateLicense: PropTypes.func.isRequired,
  onModifyLicense: PropTypes.func.isRequired,
  onRemoveLicenseMachine: PropTypes.func.isRequired,
  onAddSublicense: PropTypes.func.isRequired,
  onRemoveSublicense: PropTypes.func.isRequired,
  onDeactivateLicenseUpgrade: PropTypes.func.isRequired,
}

export default UsersPage



// WEBPACK FOOTER //
// ./webAdmin/components/users/page.js